import React from 'react';
import { LuCircleAlert, LuCircleCheck, LuInfo, LuTriangleAlert } from 'react-icons/lu';

const toneStyles = {
  info: {
    icon: LuInfo,
    classes: 'border-blue-200 bg-blue-50 text-blue-900 dark:border-blue-500/30 dark:bg-blue-500/10 dark:text-blue-100',
    iconClass: 'text-blue-600 dark:text-blue-300',
  },
  warning: {
    icon: LuTriangleAlert,
    classes: 'border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-100',
    iconClass: 'text-amber-600 dark:text-amber-300',
  },
  error: {
    icon: LuCircleAlert,
    classes: 'border-red-200 bg-red-50 text-red-900 dark:border-red-500/30 dark:bg-red-500/10 dark:text-red-100',
    iconClass: 'text-red-600 dark:text-red-300',
  },
  success: {
    icon: LuCircleCheck,
    classes: 'border-emerald-200 bg-emerald-50 text-emerald-900 dark:border-emerald-500/30 dark:bg-emerald-500/10 dark:text-emerald-100',
    iconClass: 'text-emerald-600 dark:text-emerald-300',
  },
};

/**
 * A one-line message strip across the page (a warning that editing is not supported,
 * a hint before an upload). `action` sits at the right.
 */
const Notice = ({ tone = 'info', title, children, action, className = '' }) => {
  const style = toneStyles[tone] || toneStyles.info;
  const Icon = style.icon;

  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      className={`flex items-start gap-3 rounded-lg border px-4 py-3 text-sm ${style.classes} ${className}`}
    >
      <Icon aria-hidden className={`mt-0.5 size-4 shrink-0 ${style.iconClass}`} />
      <div className="min-w-0 flex-1">
        {title && <p className="font-medium">{title}</p>}
        {children && <div className={title ? 'mt-0.5 opacity-90' : ''}>{children}</div>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
};

export default Notice;
